// extracted by mini-css-extract-plugin
export var button = "footer-hs-module--button--31d10";
export var copyright = "footer-hs-module--copyright--c775c";
export var desktop = "footer-hs-module--desktop--377d7";
export var inner = "footer-hs-module--inner--cf808";
export var linkActive = "footer-hs-module--link-active--e4229";
export var mobile = "footer-hs-module--mobile--cd9e0";
export var nav = "footer-hs-module--nav--6aa62";